// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@insite/mobius/Checkbox";
import GridContainer from "@insite/mobius/GridContainer";
import { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import GridItem, { GridItemProps } from "@store/MobiusOverrides/GridItem/GridItem";
import setRequestOutOfCycle from "@store/Framework/Store/Pages/Cart/Handlers/SetRequestOutOfCycle";
import { orderTotalProps } from "@store/Themes/common/props/checkout";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    return {
        canInitiateOutOfCycleOrders: getSettingsCollection(state).brsSettings.canInitiateOutOfCycleOrders,
        cart: getCurrentCartState(state).value,
    };
};

const mapDispatchToProps = {
    setRequestOutOfCycle,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CheckoutReviewAndSubmitNotifyStoreManagerStyles {
    container?: GridContainerProps;
    checkboxGridItem?: GridItemProps;
    checkbox?: CheckboxPresentationProps;
}

export const notifyStoreManagerStyles: CheckoutReviewAndSubmitNotifyStoreManagerStyles = {
    container: orderTotalProps.container,
    checkboxGridItem: {
        width: 12,
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.base};
        `,
    },
};

const styles = notifyStoreManagerStyles;

const CartRequestOutOfCycleOrder: FC<Props> = ({ canInitiateOutOfCycleOrders, cart, setRequestOutOfCycle }) => {
    const [requestOutOfCycleChecked, setRequestOutOfCycleChecked] = useState(false);

    useEffect(() => {
        if (cart) {
            setRequestOutOfCycleChecked(cart.properties.isOutOfCycle === "True");
        }
    }, [cart]);

    if (!canInitiateOutOfCycleOrders || !cart || cart.isAwaitingApproval) {
        return <></>;
    }

    const requestChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        if (cart) {
            setRequestOutOfCycle({ requestOutOfCycleOrder: value, cart });
        }
    };

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.checkboxGridItem}>
                <Checkbox
                    data-test-selector="cart_requestOutOfCycleOrder_checkbox"
                    onChange={requestChangeHandler}
                    checked={requestOutOfCycleChecked}
                >
                    {translate("Request Out of Cycle Order")}
                </Checkbox>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CartRequestOutOfCycleOrder),
    definition: {
        group: "Cart",
        allowedContexts: ["CartPage"],
        displayName: "Request Out of Cycle",
    },
};

export default widgetModule;
